import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import App from './App';
import './assets/css/index.css';
import './assets/css/template.css';
import * as serviceWorker from './serviceWorker';
import configureStore from './store';
import {LicenseManager} from "ag-grid-enterprise";
import globalConfig from 'utils/globalConfig';
import { MessageProvider } from './context/MessageContext';
import axios from 'axios';

// global configuration
globalConfig();

axios.interceptors.request.use((config) => {
    const raw = window.localStorage.getItem('token');
    if (raw) {
        config.headers['Authorization'] = `Bearer ${JSON.parse(raw)}`;
    }
    return config;
});

LicenseManager.setLicenseKey("SHI_International_France__on_behalf_of_Sanef_MultiApp_3Devs29_May_2020__MTU5MDcwNjgwMDAwMA==7e20a9f4f292cec4e6c182ef9af44c9b");

ReactDOM.render(
    <MessageProvider>
        <Provider store={configureStore()}>
            <App/>
        </Provider>
    </MessageProvider>,
    document.getElementById('root')
);

serviceWorker.unregister();
